<template>
<div class="lineWrap">
   <div id="mapBox">
      <!-- <lineMap ref="lineMap" :lineBasicInfo="lineBasicInfo" :selectItem="selectItem" :moveMapDistance="moveMapDistance"></lineMap> -->
   </div>
   <headerBack :backParams="backParams" @backBtn="backPage()"></headerBack>
   <div class="lineInfoWrap">
      <!-- <div class="line-icon"></div> -->
      <div class="carInfoWrap">
         <div class="carTitle">{{lineBasicInfo.lineName}}</div>
          <div class="carBox">
              
              <div class="leftBox">
                  <div class="lineTitle">
                     <div class="lineNameBox">
                        <span class="lineName"><span style="color:#666">开往</span>&nbsp;&nbsp;&nbsp;{{lineBasicInfo.lastStationName}}</span>
                     </div>
                  </div>
                  <div class="lineDeration">
                     <div class="line">全程{{(lineBasicInfo.distance/1000).toFixed(1)}}公里</div>
                     <!-- {{lineBasicInfo}} -->
                     <div class="line">首{{lineBasicInfo.firstBusTime}}&nbsp;&nbsp;末{{lineBasicInfo.lastBusTime}}</div>
                     <div class="line">票价{{lineBasicInfo.basicPrice}}元</div>
                  </div>
                  <div class="remarkBox">
                     {{lineBasicInfo.dirctionType == 1 ? lineBasicInfo.upTicketRemark : lineBasicInfo.downTicketRemark}}
                  </div>
               </div>
               <div class="rightBox" @click="changeLine">
                  <img src="../../assets/image/exchange.png" class="img">
               </div>
           </div>
           <div class="station">
                <div class="lineNameBox">
                        <span class="lineName"><span style="color:#666">本站</span>&nbsp;&nbsp;&nbsp;{{selectItem.stationName}}</span>
                  </div>
                  <div class="lineTime">
                     <div class="nearTime" v-for="(item, index) in twoBusList" :key="index">
                        <!-- 按状态分 -->
                        <!-- 状态，0：未发车  1：进站  2：出站  3：早班未发  4：晚班停运  5：无时刻表 -->
                         <div v-show="item.status ==1 ||item.status ==2">
                             <div class="time" v-show="item.runTimeName === '分钟'">
                                 <!-- <span style="position:relative;top:8px">{{item.runTime}}</span> -->
                                 <span>{{item.runTime}}</span>
                                 <div class="runTime">
                                     <div>{{item.runTimeName}}</div>
                                     <div class="wifibox"></div>
                                 </div>
                              </div>
                              <div class="content" v-show="item.runTimeName === '分钟'">
                                 {{item.seq}}站 /{{item.distance}} {{item.distanceName}}
                              </div>
                         </div>
                        <div class="waitTip" v-show="item.status ==5">--</div>
                        <div v-show="item.status ==0">
                           <div class="time" >
                               下一班次
                              </div>
                              <div class="content" >
                                  预计{{item.departureTime}}发车
                              </div>
                        </div>
                        <div class="hereTime" v-show="item.runTimeName === '秒' && item.runTime > 0">
                           <span>{{item.runTime}}</span>
                           <div class="runTime">
                              <div>{{item.runTimeName}}</div>
                              <div class="wifibox"></div>
                           </div>
                        </div>
                        <div class="hereTip" v-show="item.runTimeName === '秒' && item.runTime > 0">
                           <span class="going">即将到站</span> / {{item.distance}} {{item.distanceName}}
                        </div>
                       
                        <div class="waitTip" v-show="item.status !=5 &&item.status !=0 &&item.distance ===0 &&item.runTime === 0">已到站</div>
                     </div>
                     <!-- 查看地图 -->
                      <div class="watchMap" @click="watchMapInfo()" style="color:#22B2ED">查看地图</div>
                  </div>
           </div>
      </div>
    
   
      <publicBus ref="publicBus" :lineBasicInfo="lineBasicInfo" @selectStation="selectStation" @twoBusBack="twoBusBack" :nearSeq="nearSeq"></publicBus>
      <!-- <div class="refash" @click="pullData">
         <div class="iconfont icon-f14" :class="{iconchange: isChange}"></div>
         <div class="change-word">刷新</div>
      </div> -->
   </div>
</div>
</template>

<script>
import publicBus from './publicBus/index'
import lineMap from './lineMap'
import headerBack from '@/components/headerBack'
export default {
   components: {publicBus, lineMap,headerBack},
   data () {
      return {
         backParams:{
            title:'车辆详情'
         },
         lineInfo:{},
         tanslateNum:150, // 起始位置
         lineBasicInfo: {}, // 线路所有的基本信息
         initBusData: {},
         sectitionData: {},
         busArr: [],
         selectItem: {}, // 选中的数据
         twoBusList: [], // 两辆车的数据
         dirctionType: '1', // 1 上行 2 下行
         isChange: false,
         moveMapDistance:0,
         scrollHeight:0,
         nearSeq:'',
         flag:null,
      }
   },
   mounted () {
      this.lineInfo =  this.$route.params.line || this.$session.getSession('line')
      this.flag =  this.$route.params.flag 
      this.dirctionType = this.lineInfo.dirctionType
      this.nearSeq = this.lineInfo.seq//当前的最近站序
      this.getLineInfo()
      this.$wxHide()
   },
   beforeRouteLeave (to, from, next) {
      console.log(to, from, next)
      next()
      this.$refs.publicBus.changeDirction()
   },
   watch:{

   },
   methods: {
      // 获取线路信息 
       getLineInfo () {
         const params = {
            businessType: this.lineInfo.businessType, // 业务类型 ,1普通公交,2定制公交
            dirctionType: this.dirctionType, // 上下行  1 上行  2 下行
            lineCode: this.lineInfo.lineCode, // 线路编码
            lineType: this.lineInfo.lineType // 线路类型,1主线2区间3支线4大站快车
         }
         this.$api['station.lineBasicInfo'](params).then(res=>{
            this.lineBasicInfo = res
         })
      },
      // 返回选中的数据
      selectStation (item) {
         this.selectItem = item
      },
      // 返回最近车辆信息
      twoBusBack (arr) {
         this.twoBusList = arr
      },
      // 改变方向
      changeLine () {
        this.$refs.publicBus.changeDirction()
         this.dirctionType = this.dirctionType * 1 === 1 ? '2' : '1'
         this.getLineInfo()
      },
      // 刷新站点
      pullData () {
         this.isChange = true
         this.$refs.publicBus.refash()
         setTimeout(() => {
         this.isChange = false
         }, 300)
      },
      watchMapInfo(){
         let objParams = Object.assign({},this.lineBasicInfo,{stationName:this.lineInfo.stationName},{lineStationId:this.lineInfo.lineStationId})
         let current = this.lineBasicInfo.lineStationList.filter(item=>{
            return item.seq == this.selectItem.seq
         })
         let currentPosition = current[0]
         this.$router.push({name:"lineMap",params:{lineParams:objParams,currentPosition:currentPosition}})
         this.$session.setSession('lineParams',objParams)
         this.$session.setSession('currentPosition',currentPosition)
      },
      backPage () {
          if(this.flag == 1){
             this.$router.push({name: 'home'})
          }else{
             this.$router.push({name: 'stationDetails'})
          }
          
      },
   }
}
</script>

<style lang="scss" scoped>
$basicColor: #2196F6;
.lineWrap {
   font-size:14px;
   width: 100%;
   height: 90vh;
   overflow: hidden;
   position: relative;
   #mapBox {
      width:100%;
      height:100%;
      position: absolute;
      top:10vh;
      left: 0px;
      z-index: 1;
   }
   .lineInfoWrap {
      width: 100%;
      height:100%;
      background:  #ffffff;
      position: absolute;
      left: 0;
      // bottom: 0;
      z-index: 10000;
      overflow:hidden;
      // transform: translateY(0px);
      transition: transform .5s ease-out;
      // border-top-left-radius: 30px;
      // border-top-right-radius: 30px;
      .line-icon {
         width: 50px;
         height: 3px;
         border-radius: 1px;
         background: #e9e7ef;
         margin: 5px auto;
      }
      .carInfoWrap{
         box-shadow: 2px 2px 13px 1px #DDE2F7;
         margin: 10px 15px;
         border-radius: 10px;
          .carTitle{
             padding:0px 15px;
            padding-top:5px;
            font-size: 16px;
            color: #333;
            font-weight: 600;
          }
          .carBox{
            padding-bottom: 0.1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #eee;
            .leftBox{
               .lineTitle {
                  padding:6px 15px;
                  display: flex;
                  align-content: center;
                  justify-content: space-between;
               .lineNameBox{
                  flex: 1 auto;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-all;
                  .lineName {
                     font-size:13px;
                     color:#000;
                     .iconfont {
                        display: inline-block;
                        margin: 0 5px;
                     }
                  }
               }
               .changeLine{
                  width: 60px;
                  display: flex;
                  align-items: center;
                  color: #333;
                  font-size: 18px;
                  font-weight: 600;
                  .change{
                     margin-left: 5px;
                  }
               }
              }
            }
            .rightBox{
               width: 26px;
               height: 26px;
               background-color: #22B2ED;
               margin-right: 0.2rem;
               border-radius: 5px;
               text-align: center;
               line-height: 26px;
               margin-top:-0.2rem;
               transform: rotate(90deg);
               .img{
                  width:10px;
                  height:12px;
               }
            }
            
         .lineDeration {
            display: flex;
            align-items: center;
            padding-left: 15px;
            font-size:13px;
            color:#999;
            .line {
               padding-right: 10px;
              }
            }
           .remarkBox{
               font-size: 13px;
               padding-left: 15px;
               padding-top: 6px;
               color: #999;
               max-height:36px;
               overflow: hidden;
               text-overflow: ellipsis;
           }
         }
         .station {
               .lineNameBox{
                  flex: 1 auto;
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  word-break: break-all;
                  padding:0px 15px;
                  padding-top:5px;
                  .lineName {
                     font-size:13px;
                     color:#000;
                     .iconfont {
                        display: inline-block;
                        margin: 0 5px;
                     }
                  }
               }
               .lineTime {
                  display: flex;
                  align-items: center;
                  justify-content: space-around;
                  padding: 5px 15px;
                  height: 60px;
                  padding-top:15px;
                  .nearTime {
                     color:#333;
                     font-size: 12px;
                     text-align: center;
                    
                     .time {
                        font-size: 14px;
                        color: #22B2ED;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        span {
                           font-size: 0.18rem;
                           position:relative;
                           font-weight:600;
                           
                        }
                        }
                  .hereTime {
                     font-size: 14px;
                     color: #FF8056;
                     display: flex;
                     align-items: center;
                     justify-content: center;
                     span {
                        font-size: 0.18rem;
                     }
                  }
                  .runTime {
                     display: flex;
                     // flex-direction: column;
                     justify-content: center;
                     margin-left: 3px;
                     .wifibox {
                        width:16px;
                        height:16px;
                        background-image: url('../../assets/image/wifi1.png');
                        background-position: center;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                        animation:mymove 2s infinite;
                        position: relative;
                        top:-4px;
                        left: 4px;
                     }
                  }
                  @keyframes mymove {
                     0% { background-image: url('../../assets/image/wifi1.png');}
                     50% {background-image: url('../../assets/image/wifi2.png');}
                     100% {background-image: url('../../assets/image/wifi3.png');}
                  }
                  .content {
                     margin: 3px;
                     font-size: 14px;
                     color: #333;
                     font-weight:600;
                  }
                  .hereTip {
                     margin: 3px;
                     font-size: 14px;
                     color: #FF8056;
                     .going {
                        font-size: 12px;
                     }
                  }
                  .waitTip {
                     font-size: 15px;
                     color: #22B2ED;
                  }
            }
         }
      }
      }
    
   
      .refash {
         width: 150px;
         height: 40px;
         background: #f0f0f4;
         border-radius: 20px;
         font-size: 16px;
         position: absolute;
         left: 50%;
         bottom: 70px;
         margin-left: -75px;
         display: flex;
         justify-content: center;
         align-items: center;
         color: $basicColor;
         .iconfont {
            font-size: 16px;
         }
         .change-word {
            font-size: 16px;
            margin-left: 5px;
         }
      }
      .iconchange {
         animation: 0.3s road linear infinite;
      }
      @keyframes road {
         0% {
         transform: rotate(0deg);
         }
         100% {
         transform: rotate(360deg);
         }
      }
   }
}

</style>